<template>
    <div>
      <loading
        :active.sync="loader.isLoading"
        :can-cancel="loader.canCancel"
        :is-full-page="loader.fullPage"
        :color="loader.color"
        :height="loader.height"
        :width="loader.width"
        :background-color="loader.backgroundColor"
        :loader="loader.loader">
      </loading>
      <div class="row">
        <div class="col-md-12">
            <div class="top-list-small-toolbar">
                <div>
                    <h4 class="text-primary">Report Daily Transaction</h4>
                    <div class="form-inline">
                        <div class="button-group">
                            <span><b>Company:</b> </span>
                            <select v-model="company_no" class="btn btn-sm btn-soft-outline-primary">
                                <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                            </select>
                        </div>
                        <div class="button-group ml-1">
                            <span class="mr-1"><b>Date:</b> </span>
                            <datetime v-model="date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                            <!-- <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker> -->
                        </div>
                        <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                        <button type="button" class="btn btn-sm  btn-hard-primary waves-light waves-effect" @click="process">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Process
                        </button>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="row" style="margin-top: 100px">
        <div class="col-md-3">
            <div class="card report-card">
                <div class="card-body">
                    <div class="float-right">
                        <i class="dripicons-user-group report-main-icon"></i>
                    </div>
                    <h5><span class="badge badge-info">Total Tunai</span></h5>
                    <h3 class="my-3">
                        <span v-if="loadingSales === false">
                        <div class="loadingio-spinner-bars-km984sg9h2">
                            <div class="ldio-m41ff6uvz8">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            </div>
                        </div>
                        </span>
                        <span v-else>
                        {{ totalTunai | currency }}
                        </span>
                    </h3>
                </div>
                <!--end card-body-->
            </div>
        </div>
        <div class="col-md-3">
            <div class="card report-card">
                <div class="card-body">
                    <div class="float-right">
                        <i class="dripicons-user-group report-main-icon"></i>
                    </div>
                    <h5><span class="badge badge-success">Total Income</span></h5>
                    <h3 class="my-3">
                        <span v-if="loadingSales === false">
                        <div class="loadingio-spinner-bars-km984sg9h2">
                            <div class="ldio-m41ff6uvz8">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            </div>
                        </div>
                        </span>
                        <span v-else>
                        {{ totalIncome | currency }}
                        </span>
                    </h3>
                </div>
                <!--end card-body-->
            </div>
        </div>
        <div class="col-md-3">
            <div class="card report-card">
                <div class="card-body">
                    <div class="float-right">
                        <i class="dripicons-user-group report-main-icon"></i>
                    </div>
                    <h5><span class="badge badge-warning">Total Outcome</span></h5>
                    <h3 class="my-3">
                        <span v-if="loadingSales === false">
                        <div class="loadingio-spinner-bars-km984sg9h2">
                            <div class="ldio-m41ff6uvz8">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            </div>
                        </div>
                        </span>
                        <span v-else>
                        {{ totalOutcome | currency }}
                        </span>
                    </h3>
                </div>
                <!--end card-body-->
            </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive">
                            <div class="text-center"><h5>.: Purchasing :.</h5></div>
                            <table class="table table-item mb-0 table-sm table-striped table-hover table-striped">
                                <thead>
                                  <th></th>
                                  <th>Report</th>
                                  <th>Payment No.</th>
                                  <th>Date</th>
                                  <th>Vendor</th>
                                  <th>Method</th>
                                  <th>Type</th>
                                  <th>Account</th>
                                  <th class="text-right">Subtotal</th>
                                  <th class="text-right">Discount</th>
                                  <th class="text-right">Round</th>
                                  <th class="text-right">Total</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(d, index) in dataPurchasing" :key="index">
                                      <td>
                                        <label class="form-checkbox" v-if="d.level === 1">
                                          <input type="checkbox" :value="d.payment_no" v-model="selectedPurchasing" @change="uncheckReportPurchasingPayment(index)"><i class="form-icon"></i>
                                        </label>
                                      </td>
                                      <td>
                                        <span v-if="d.report === true"><i class="fa fa-check" style="color: green"></i></span>
                                      </td>
                                      <td>
                                        <span v-if="d.level === 1"><b>{{ d.payment_no }}</b></span>
                                        <span v-else class="ml-2">{{ d.payment_no }}</span>
                                      </td>
                                      <td>
                                        <span v-if="d.level === 1">{{ d.payment_date | dateFormat('DD/MM/YYYY') }}</span>
                                      </td>
                                      <td>
                                        <span v-if="d.level === 1">{{ d.vendor }}</span>
                                      </td>
                                      <td>
                                        <span v-if="d.level === 1">{{ d.method }}</span>
                                      </td>
                                      <td>
                                        <span v-if="d.level === 1">{{ d.type }}</span>
                                      </td>
                                      <td>
                                        <span v-if="d.level === 1"><b>[{{ d.account_code }}]</b> {{ d.account }}</span>
                                      </td>
                                      <td class="text-right">
                                        <span v-if="d.level === 1">{{ d.subtotal | currency }}</span>
                                      </td>
                                      <td class="text-right">
                                        <span v-if="d.level === 1">{{ d.discount | currency }}</span>
                                      </td>
                                      <td class="text-right">
                                        <span v-if="d.level ===1">{{ d.round | currency }}</span>
                                      </td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td class="text-right"><b>Total Tunai:</b></td>
                                      <td class="text-right"><b>{{ totalPurchasingCash | currency }}</b></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      <td></td>
                                        <td></td>
                                        <td class="text-right"><b>Total Bank:</b></td>
                                        <td class="text-right"><b>{{ totalPurchasingBank | currency }}</b></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td class="text-right"><b>Total Giro:</b></td>
                                        <td class="text-right"><b>{{ totalPurchasingGiro | currency }}</b></td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td class="text-right"><b>Total:</b></td>
                                      <td class="text-right"><b>{{ totalPurchasing | currency }}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive">
                            <div class="text-center"><h5>.: Sales :.</h5></div>
                            <table class="table table-item mb-0 table-sm table-striped table-hover table-striped">
                                <thead>
                                  <th></th>
                                  <th>Report</th>
                                  <th>Payment No.</th>
                                  <th>Date</th>
                                  <th>Customer</th>
                                  <th>Method</th>
                                  <th>Type</th>
                                  <th>Account</th>
                                  <th class="text-right">Subtotal</th>
                                  <th class="text-right">Discount</th>
                                  <th class="text-right">Round</th>
                                  <th class="text-right">Total</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(d, index) in dataSales" :key="index">
                                      <td>
                                        <label class="form-checkbox" v-if="d.level === 1">
                                          <input type="checkbox" :value="d.payment_no" v-model="selectedSales" @change="uncheckReportSalesPayment(index)"><i class="form-icon"></i>
                                        </label>
                                      </td>
                                      <td>
                                        <span v-if="d.report === true"><i class="fa fa-check" style="color: green"></i></span>
                                      </td>
                                      <td>
                                        <span v-if="d.level === 1"><b>{{ d.payment_no }}</b></span>
                                        <span v-else class="ml-2">{{ d.payment_no }}</span>
                                      </td>
                                      <td>
                                        <span v-if="d.level === 1">{{ d.payment_date | dateFormat('DD/MM/YYYY') }}</span>
                                      </td>
                                      <td>
                                        <span v-if="d.level === 1">{{ d.customer }}</span>
                                      </td>
                                      <td>
                                        <span v-if="d.level === 1">{{ d.method }}</span>
                                      </td>
                                      <td>
                                        <span v-if="d.level === 1">{{ d.type }}</span>
                                      </td>
                                      <td>
                                        <span v-if="d.level === 1"><b>[{{ d.account_code }}]</b> {{ d.account }}</span>
                                      </td>
                                      <td class="text-right">
                                        <span v-if="d.level === 1">{{ d.subtotal | currency }}</span>
                                      </td>
                                      <td class="text-right">
                                        <span v-if="d.level === 1">{{ d.discount | currency }}</span>
                                      </td>
                                      <td class="text-right">
                                        <span v-if="d.level ===1">{{ d.round | currency }}</span>
                                      </td>
                                      <td class="text-right">{{ d.total | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td class="text-right"><b>Total Tunai:</b></td>
                                      <td class="text-right"><b>{{ totalSalesCash | currency }}</b></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td class="text-right"><b>Total Bank:</b></td>
                                        <td class="text-right"><b>{{ totalSalesCash | currency }}</b></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                      <td></td>
                                        <td class="text-right"><b>Total Giro:</b></td>
                                        <td class="text-right"><b>{{ totalSalesGiro | currency }}</b></td>
                                    </tr>
                                    <tr>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td class="text-right"><b>Total:</b></td>
                                      <td class="text-right"><b>{{ totalSales | currency }}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <div class="text-center"><h5>.: Kas Kecil :.</h5></div>
                      <table class="table table-sm table-item table-hover table-striped">
                        <thead>
                          <th></th>
                          <th>Report</th>
                          <th>Date</th>
                          <th>Company</th>
                          <th>Ref No.</th>
                          <th>Method</th>
                          <th>Category</th>
                          <th>Type</th>
                          <th>Account</th>
                          <th class="text-right">Amount</th>
                        </thead>
                        <tbody>
                          <tr v-for="(d, index) in dataKasKecil" :key="index">
                            <td>
                              <label class="form-checkbox" v-if="d.type !== 'saldo'">
                                <input type="checkbox" :value="d.id" v-model="selected"><i class="form-icon"></i>
                              </label>
                            </td>
                            <td></td>
                            <td>{{ d.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                            <td>{{ d.company }}</td>
                            <td>{{ d.ref_no }}</td>
                            <td>{{ d.method}}</td>
                            <td>{{ d.category }}</td>
                            <td>{{ d.type }}</td>
                            <td><b v-if="d.account_code !== null">[{{ d.account_code }}]</b> {{ d.account }}</td>
                            <td class="text-right">{{ d.amount | currency }}</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Total Saldo:</b></td>
                            <td class="text-right"><b>{{ totalKasKecilSaldo | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Total Income:</b></td>
                            <td class="text-right"><b>{{ totalKasKecilIncome | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Total Outcome:</b></td>
                            <td class="text-right"><b>{{ totalKasKecilOutcome | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Outstanding:</b></td>
                            <td class="text-right"><b>{{ totalKasKecilOutstanding | currency }}</b></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <div class="text-center"><h5>.: Kas Besar :.</h5></div>
                      <table class="table table-sm table-item table-hover table-striped">
                        <thead>
                          <th></th>
                          <th>Report</th>
                          <th>Date</th>
                          <th>Company</th>
                          <th>Ref No.</th>
                          <th>Method</th>
                          <th>Category</th>
                          <th>Type</th>
                          <th>Account</th>
                          <th class="text-right">Amount</th>
                        </thead>
                        <tbody>
                          <tr v-for="(d, index) in dataKasBesar" :key="index">
                            <td>
                              <label class="form-checkbox" v-if="d.type !== 'saldo'">
                                <input type="checkbox" :value="d.id" v-model="selected"><i class="form-icon"></i>
                              </label>
                            </td>
                            <td></td>
                            <td>{{ d.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                            <td>{{ d.company }}</td>
                            <td>{{ d.ref_no }}</td>
                            <td>{{ d.method}}</td>
                            <td>{{ d.category }}</td>
                            <td>{{ d.type }}</td>
                            <td><b v-if="d.account_code !== null">[{{ d.account_code }}]</b> {{ d.account }}</td>
                            <td class="text-right">{{ d.amount | currency }}</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Total Saldo:</b></td>
                            <td class="text-right"><b>{{ totalKasBesarSaldo | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Total Income:</b></td>
                            <td class="text-right"><b>{{ totalKasBesarIncome | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Total Outcome:</b></td>
                            <td class="text-right"><b>{{ totalKasBesarOutcome | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Outstanding:</b></td>
                            <td class="text-right"><b>{{ totalKasBesarOutstanding | currency }}</b></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <div class="text-center"><h5>.: Kas Produksi Pintu :.</h5></div>
                      <table class="table table-sm table-item table-hover table-striped">
                        <thead>
                          <th></th>
                          <th>Report</th>
                          <th>Date</th>
                          <th>Company</th>
                          <th>Ref No.</th>
                          <th>Method</th>
                          <th>Category</th>
                          <th>Type</th>
                          <th>Account</th>
                          <th class="text-right">Amount</th>
                        </thead>
                        <tbody>
                          <tr v-for="(d, index) in dataKasProduksiPintu" :key="index">
                            <td>
                              <label class="form-checkbox" v-if="d.type !== 'saldo'">
                                <input type="checkbox" :value="d.id" v-model="selected"><i class="form-icon"></i>
                              </label>
                            </td>
                            <td></td>
                            <td>{{ d.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                            <td>{{ d.company }}</td>
                            <td>{{ d.ref_no }}</td>
                            <td>{{ d.method}}</td>
                            <td>{{ d.category }}</td>
                            <td>{{ d.type }}</td>
                            <td><b v-if="d.account_code !== null">[{{ d.account_code }}]</b> {{ d.account }}</td>
                            <td class="text-right">{{ d.amount | currency }}</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Total Saldo:</b></td>
                            <td class="text-right"><b>{{ totalKasProduksiPintuSaldo | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Total Income:</b></td>
                            <td class="text-right"><b>{{ totalKasProduksiPintuIncome | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Total Outcome:</b></td>
                            <td class="text-right"><b>{{ totalKasProduksiPintuOutcome | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Outstanding:</b></td>
                            <td class="text-right"><b>{{ totalKasProduksiPintuOutstanding | currency }}</b></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <div class="text-center"><h5>.: Kas Produksi Fiber :.</h5></div>
                      <table class="table table-sm table-item table-hover table-striped">
                        <thead>
                          <th></th>
                          <th>Report</th>
                          <th>Date</th>
                          <th>Company</th>
                          <th>Ref No.</th>
                          <th>Method</th>
                          <th>Category</th>
                          <th>Type</th>
                          <th>Account</th>
                          <th class="text-right">Amount</th>
                        </thead>
                        <tbody>
                          <tr v-for="(d, index) in dataKasProduksiFiber" :key="index">
                            <td>
                              <label class="form-checkbox" v-if="d.type !== 'saldo'">
                                <input type="checkbox" :value="d.id" v-model="selected"><i class="form-icon"></i>
                              </label>
                            </td>
                            <td></td>
                            <td>{{ d.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                            <td>{{ d.company }}</td>
                            <td>{{ d.ref_no }}</td>
                            <td>{{ d.method}}</td>
                            <td>{{ d.category }}</td>
                            <td>{{ d.type }}</td>
                            <td><b v-if="d.account_code !== null">[{{ d.account_code }}]</b> {{ d.account }}</td>
                            <td class="text-right">{{ d.amount | currency }}</td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Total Saldo:</b></td>
                            <td class="text-right"><b>{{ totalKasProduksiFiberSaldo | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Total Income:</b></td>
                            <td class="text-right"><b>{{ totalKasProduksiFiberIncome | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Total Outcome:</b></td>
                            <td class="text-right"><b>{{ totalKasProduksiFiberOutcome | currency }}</b></td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="text-right"><b>Outstanding:</b></td>
                            <td class="text-right"><b>{{ totalKasProduksiFiberOutstanding | currency }}</b></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-md-6"><pre>{{ dataRaw }}</pre></div> -->
        <!-- <div class="col-md-6"><pre>{{ dataCash }}</pre></div> -->
      </div>
    </div>
</template>
<script>
import Axios from 'axios'
import { financeUrl, getHeader, reportTransactionUrl } from '../../config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'

export default {
  name: 'DailyTransaction',
  components: {
    Loading
  },
  computed: {
    ...mapState({
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser
    }),
    dataProcessPurchasing () {
      var array = this.selectedPurchasing
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          payment_no: array[i]
        }
        loop.push(obj)
      }
      return loop
    },
    dataProcessSales () {
      var array = this.selectedSales
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          payment_no: array[i]
        }
        loop.push(obj)
      }
      return loop
    },
    dataProcess () {
      var array = this.selected
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          id: array[i]
        }
        loop.push(obj)
      }
      return loop
    },
    totalIncome () {
      var sum = 0
      sum = this.totalSales + this.totalKasKecilIncome + this.totalKasBesarIncome + this.totalKasProduksiPintuIncome + this.totalKasProduksiFiberIncome
      return sum
    },
    totalOutcome () {
      var sum = 0
      sum = this.totalPurchasing + this.totalKasKecilOutcome + this.totalKasBesarOutcome + this.totalKasProduksiPintuOutcome + this.totalKasProduksiFiberOutcome
      return sum
    },
    totalKas () {
      var sum = 0
      sum = this.totalKasKecil + this.totalKasBesar + this.totalKasProduksiFiber + this.totalKasProduksiPintu
      return sum
    },
    totalTunai () {
      var sum = 0
      sum = this.totalSalesCash + this.totalKasKecilOutstanding + this.totalKasBesarOutstanding + this.totalKasProduksiPintuOutstanding + this.totalKasProduksiFiberOutstanding - this.totalPurchasingCash
      return sum
    },
    totalBank () {
      var sum = 0
      sum = this.totalSalesBank - this.totalPurchasingBank
      return sum
    },
    totalGiro () {
      var sum = 0
      sum = this.totalSalesGiro - this.totalPurchasingGiro
      return sum
    },
    totalTransaction () {
      var sum = 0
      sum = this.totalSalesCash + this.totalKasKecil + this.totalKasBesar + this.totalKasProduksiFiber + this.totalKasProduksiPintu + this.totalPurchasingBank + this.totalSalesBank - this.totalPurchasingCash
      return sum
    },
    dataSales () {
      return this.dataRaw.filter(d => d.category === 'sales').filter(d => d.type !== 'saldo')
    },
    totalSalesCash () {
      var sum = 0
      var array = this.dataSales.filter(d => d.method === 'Tunai').filter(d => d.level === 1)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalSalesBank () {
      var sum = 0
      var array = this.dataSales.filter(d => d.method === 'Transfer Bank').filter(d => d.level === 1)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalSalesGiro () {
      var sum = 0
      var array = this.dataSales.filter(d => d.method === 'Giro').filter(d => d.level === 1)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalSales () {
      var sum = 0
      sum = this.totalSalesCash + this.totalSalesBank + this.totalSalesGiro
      return sum
    },
    dataPurchasing () {
      return this.dataRaw.filter(d => d.category === 'purchasing')
    },
    totalPurchasing () {
      var sum = 0
      sum = this.totalPurchasingCash + this.totalPurchasingBank + this.totalPurchasingGiro
      return sum
    },
    totalPurchasingCash () {
      var sum = 0
      var array = this.dataPurchasing.filter(d => d.method === 'Tunai').filter(d => d.level === 1)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalPurchasingBank () {
      var sum = 0
      var array = this.dataPurchasing.filter(d => d.method === 'Transfer Bank').filter(d => d.level === 1)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalPurchasingGiro () {
      var sum = 0
      var array = this.dataPurchasing.filter(d => d.method === 'Giro').filter(d => d.level === 1)
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    dataKasKecil () {
      return this.dataCash.filter(d => d.category_id === 'kas-kecil')
    },
    totalKasKecilIncome () {
      var sum = 0
      var array = this.dataKasKecil
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'income' || array[i].type === 'saldo') {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    totalKasKecilOutcome () {
      var sum = 0
      var array = this.dataKasKecil
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'outcome') {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    totalKasKecilSaldo () {
      var sum = 0
      var array = this.dataKasKecil
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'saldo') {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    totalKasKecilOutstanding () {
      var sum = 0
      sum = this.totalKasKecilSaldo + this.totalKasKecilIncome - this.totalKasKecilOutcome
      return sum
    },
    totalKasKecil () {
      var sum = 0
      var array = this.dataKasKecil
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'income' || array[i].type === 'saldo') {
          sum += parseFloat(array[i].amount)
        } else {
          sum -= parseFloat(array[i].amount)
        }
      }
      return sum
    },
    dataKasBesar () {
      return this.dataCash.filter(d => d.category_id === 'kas-besar')
    },
    totalKasBesarIncome () {
      var sum = 0
      var array = this.dataKasBesar
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'income' || array[i].type === 'saldo') {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    totalKasBesarOutcome () {
      var sum = 0
      var array = this.dataKasBesar
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'outcome') {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    totalKasBesarSaldo () {
      var sum = 0
      var array = this.dataKasBesar
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'saldo') {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    totalKasBesarOutstanding () {
      var sum = 0
      sum = this.totalKasBesarSaldo + this.totalKasBesarIncome - this.totalKasBesarOutcome
      return sum
    },
    totalKasBesar () {
      var sum = 0
      var array = this.dataKasBesar
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'income' || array[i].type === 'saldo') {
          sum += parseFloat(array[i].amount)
        } else {
          sum -= parseFloat(array[i].amount)
        }
      }
      return sum
    },
    dataKasProduksiPintu () {
      return this.dataCash.filter(d => d.category_id === 'kas-produksi-pintu')
    },
    totalKasProduksiPintuIncome () {
      var sum = 0
      var array = this.dataKasProduksiPintu
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'income' || array[i].type === 'saldo') {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    totalKasProduksiPintuOutcome () {
      var sum = 0
      var array = this.dataKasProduksiPintu
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'outcome') {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    totalKasProduksiPintuSaldo () {
      var sum = 0
      var array = this.dataKasProduksiPintu
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'saldo') {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    totalKasProduksiPintuOutstanding () {
      var sum = 0
      sum = this.totalKasProduksiPintuSaldo + this.totalKasProduksiPintuIncome - this.totalKasProduksiPintuOutcome
      return sum
    },
    totalKasProduksiPintu () {
      var sum = 0
      var array = this.dataKasProduksiPintu
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'income' || array[i].type === 'saldo') {
          sum += parseFloat(array[i].amount)
        } else {
          sum -= parseFloat(array[i].amount)
        }
      }
      return sum
    },
    dataKasProduksiFiber () {
      return this.dataCash.filter(d => d.category_id === 'kas-produksi-fiber')
    },
    totalKasProduksiFiberIncome () {
      var sum = 0
      var array = this.dataKasProduksiFiber
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'income' || array[i].type === 'saldo') {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    totalKasProduksiFiberOutcome () {
      var sum = 0
      var array = this.dataKasProduksiFiber
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'outcome') {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    totalKasProduksiFiberSaldo () {
      var sum = 0
      var array = this.dataKasProduksiFiber
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'saldo') {
          sum += parseFloat(array[i].amount)
        }
      }
      return sum
    },
    totalKasProduksiFiberOutstanding () {
      var sum = 0
      sum = this.totalKasProduksiFiberSaldo + this.totalKasProduksiFiberIncome - this.totalKasProduksiFiberOutcome
      return sum
    },
    totalKasProduksiFiber () {
      var sum = 0
      var array = this.dataKasProduksiFiber
      for (let i = 0; i < array.length; i++) {
        if (array[i].type === 'income' || array[i].type === 'saldo') {
          sum += parseFloat(array[i].amount)
        } else {
          sum -= parseFloat(array[i].amount)
        }
      }
      return sum
    },
    companyData () {
      var obj = {
        name: null,
        address: null
      }
      const cmp = this.companyList.find(d => d.company_no === this.company_no)
      if (cmp) {
        obj = {
          name: cmp.name,
          address: cmp.address
        }
      }
      return obj
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    if (window.localStorage.getItem('authUser')) {
      const authU = window.localStorage.getItem('authUser')
      const auth = JSON.parse(authU)
      console.log('auth session')
      console.log(auth)
      this.company_no = auth.user.company_no
    }
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      loadingSales: true,
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      company_no: null,
      startDate: [date1, date2],
      date: null,
      begin: new Date(),
      end: new Date(),
      contact: null,
      month: date.getMonth() + 1,
      year: date.getFullYear(),
      saldoAwal: 0,
      saldoAkhir: null,
      totalLabaRugi: null,
      dataRaw: [],
      dataCash: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      selected: [],
      selectedPurchasing: [],
      selectedSales: []
    }
  },
  methods: {
    async uncheckReportKasPayment (index) {
      var po = this.dataKasKecil[index]
      var array = this.selected
      var status = false
      for (let i = 0; i < array.length; i++) {
        if (array[i] === po.payment_no) {
          status = true
        } else {
          status = false
        }
      }
      if (status === false) {
        var obj = {
          payment_no: po.payment_no
        }
        await Axios.post(reportTransactionUrl + '/remove-report-payment', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    async uncheckReportSalesPayment (index) {
      var po = this.dataSales[index]
      var array = this.selectedSales
      var status = false
      for (let i = 0; i < array.length; i++) {
        if (array[i] === po.payment_no) {
          status = true
        } else {
          status = false
        }
      }
      if (status === false) {
        var obj = {
          payment_no: po.payment_no
        }
        await Axios.post(reportTransactionUrl + '/remove-report-payment', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    async uncheckReportPurchasingPayment (index) {
      var po = this.dataPurchasing[index]
      var array = this.selectedPurchasing
      var status = false
      for (let i = 0; i < array.length; i++) {
        if (array[i] === po.payment_no) {
          status = true
        } else {
          status = false
        }
      }
      if (status === false) {
        var obj = {
          payment_no: po.payment_no
        }
        await Axios.post(reportTransactionUrl + '/remove-report-payment', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    editJournal: function (id) {
      alert(id)
    },
    async process () {
      var obj = {
        id: null,
        report_date: this.date,
        username: this.authUser.username,
        notes: null,
        company_no: this.company_no,
        purchasings: this.dataProcessPurchasing,
        sales: this.dataProcessSales,
        cash: this.dataProcess
      }
      console.log(reportTransactionUrl)
      console.log(obj)
      await Axios.post(reportTransactionUrl, obj, { headers: getHeader() })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selectedPurchasing = []
      this.selectedSales = []
      this.selected = []
      var url = financeUrl + '/daily-transaction'
      console.log(url)
      var data = {
        date: this.date,
        company_no: this.company_no
      }
      console.log(data)
      await Axios.post(url, data, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.dataRaw = response.data.data
          this.dataCash = response.data.data_cash
          // selected purchasing
          var arrPo = this.dataRaw.filter(d => d.category === 'purchasing')
          for (let i = 0; i < arrPo.length; i++) {
            if (arrPo[i].report === true) {
              if (arrPo[i].level === 1) {
                this.selectedPurchasing.push(arrPo[i].payment_no)
              }
            }
          }
          var arrSales = this.dataRaw.filter(d => d.category === 'sales')
          for (let i = 0; i < arrSales.length; i++) {
            if (arrSales[i].report === true) {
              this.selectedSales.push(arrSales[i].payment_no)
            }
          }
          for (let i = 0; i < this.dataKasKecil.length; i++) {
            if (this.dataKasKecil[i].report === true) {
              this.selected.push(this.dataKasKecil[i].id)
            }
          }
          for (let i = 0; i < this.dataKasBesar.length; i++) {
            if (this.dataKasBesar[i].report === true) {
              this.selected.push(this.dataKasBesar[i].id)
            }
          }
          for (let i = 0; i < this.dataKasProduksiFiber.length; i++) {
            if (this.dataKasProduksiFiber[i].report === true) {
              this.selected.push(this.dataKasProduksiFiber[i].id)
            }
          }
          for (let i = 0; i < this.dataKasProduksiPintu.length; i++) {
            if (this.dataKasProduksiPintu[i].report === true) {
              this.selected.push(this.dataKasProduksiPintu[i].id)
            }
          }
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>

<style scoped>
  .first-col {
    position: absolute;
    width: 5em;
    margin-left: -5em;
  }
</style>
